import { FC } from "react";
import { Autocomplete, TextField } from "@mui/material";
import intl from "components/i18n/ReactIntlWrapper";
import { sortCollection } from "../../../../common/utils";
import { SORT_TYPES } from "../../../../common/constants";

type EmployeeSelectProps = {
  handleEmployeeChange: any;
  selectedEmployee: any;
  employees: any;
  disabled: any;
  newUser: boolean;
  id: any;
  securityRoles: any;
  edit: boolean;
  setHiddenRole?: any;
  errors: any;
};

const EmployeeSelect: FC<EmployeeSelectProps> = ({
  handleEmployeeChange,
  employees,
  selectedEmployee,
  disabled,
  newUser,
  id,
  edit,
  setHiddenRole = false,
  errors
}) => {
  const employeesSortedByName = sortCollection(
    employees,
    "name",
    SORT_TYPES.ASC
  );

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 56,
      minHeight: 56,
    }),
    menu: (base) => ({
      ...base,
      maxHeight: "18.7rem",
    }),
  };

  const handleChange = (selectedOption: any) => {
    handleEmployeeChange(selectedOption, id);
  };

  const handleMenuOpen = () => {
    setHiddenRole(true);
  };

  const handleMenuClose = () => {
    setHiddenRole(false);
  };

  return (
    <Autocomplete
    id="idEmployee"
    options={employeesSortedByName || []}
    getOptionLabel={(option) => `${option.name} ${option.lastName}`}
    isOptionEqualToValue={(option, value) => option.id === value.id}
    value={
      employees && selectedEmployee
        ? employees.find((employee) => employee.id === selectedEmployee) || null
        : null
    }
    onChange={(event, newValue) => handleChange(newValue)}
    disabled={disabled}
    onOpen={setHiddenRole ? handleMenuOpen : undefined}
    onClose={setHiddenRole ? handleMenuClose : undefined}
    loading={employees == null}
    renderInput={(params) => (
      <TextField
        {...params}
        fullWidth
        label={`${intl.get("employeeProjectForm.employee")}`}
        placeholder={intl.get("employeeProjectForm.placeholder.employee")}
        error={!!errors.employee}
        helperText={errors.employee}
        size="small"
      />
    )}
  />
  );
};

export default EmployeeSelect;
